module.exports = function validate(code){
	var originalControllDigit = code.slice(-1);
	var max = code.length - 2;
	var sum = 0;
	for(let counter = 0; counter <= max; counter++){
		let digit = Number(code.charAt(max - counter));
		if(counter % 2 == 0) {
			digit = digit * 2;
			if(digit < 10){
				sum += digit;
			} else {
				sum += digit - 9;
			}
		} else {
			sum += digit;
		}
	}

	sum=sum%10;
	var calculatedControlDigit = sum == 0 ? 0 : 10 - sum;
	return originalControllDigit == calculatedControlDigit;
}